import p1 from "../imgs/p1.jpg";
import p2 from "../imgs/p2.png";
import p3 from "../imgs/p3.png";
import p4 from "../imgs/p4.jpg";
import p5 from "../imgs/p5.png";
import p6 from "../imgs/p6.png";
import p7 from "../imgs/p7.jpg";
import p10 from "../imgs/p10.jpg";

export const ProjectsList = [
  {
    id: 1,
    name: "E-commerce product page using react.js(context api/vite)",
    pic: p10,
    live: "https://product-page-yacine.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-e-commerce-product-page",
    tags: ["React", "Context API", "Vite"],
  },
  {
    id: 2,
    name: "newsletter sign-up form with using react.js",
    pic: p1,
    live: "https://newsletter-yacine.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-Newsletter-sign-up-form-with-success-message",
    tags: ["React", "Form validation"],
  },
  {
    id: 3,
    name: "manage landing page project using react.js with vite",
    pic: p7,
    live: "https://landing-page-yacine.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-manage-landing-page",
    tags: ["React", "Vite", "CSS"],
  },
  {
    id: 4,
    name: "react-crypto-app",
    pic: p3,
    live: "https://last-update-crypto-adelmadrid-app.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-crypto-app",
    tags: ["React", "REST API", "Context API"],
  },
  {
    id: 5,
    name: "Space multi-page website using react.js(vite,react-router-dom)",
    pic: p4,
    live: "https://space-yacine-web.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-space-website",
    tags: ["React", "React Router", "Vite"],
  },
  {
    id: 6,
    name: "react-food-website",
    pic: p5,
    live: "https://food-adelmadrid.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-food-website",
    tags: ["React", "CSS"],
  },
  {
    id: 7,
    name: "react-shopping-card",
    pic: p6,
    live: "https://commerce-adelmadrid.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-shopping-card",
    tags: ["React", "Context API"],
  },
  {
    id: 8,
    name: "react-todolist-app",
    pic: p2,
    live: "https://last-update-adelmadrid-todolist.netlify.app/",
    repo: "https://github.com/AdelYACINE/react-todo-list-app",
    tags: ["React", "Hooks"],
  },
];
